<template>
  <div id="allsettings" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row-center mt-5">
        <div class="col-xs-12 col-md-10 col-lg-10 mx-auto">
          <div class="content-toggle">
            <div class="toggle-search">
              <button type="button" name="btn_Comofunciona" class="btn_optionlogin" @click="ActiveBtnComofunciona"
                :class="{ bn_active: activeBtn === 'Comofunciona' }">
                <span class="cta ml-0"> ¿Cómo funciona?</span>
              </button>

              <button type="button" name="btn_Ajustes" class="btn_optionlogin" @click="ActivebtnAjustes"
                :class="{ bn_active: activeBtn === 'Ajustes' }">
                <span class="cta"> Ajustes de puntajes</span>
              </button>
              <button type="button" name="btn_Actualizacion" class="btn_optionlogin" @click="ActivebtnActualizacion"
                :class="{ bn_active: activeBtn === 'Actualizacion' }">
                <span class="cta"> Actualización de la información</span>
              </button>
            </div>
          </div>

          <div v-if="activeBtn == 'Comofunciona'">

            <vueper-slides autoplay :pause-on-hover="pauseOnHover" :slide-content-outside="contentPosition"
              class="no-shadow" :visible-slides="1.5" :gap="1" :slide-ratio="1 / 4" :dragging-distance="170">
              <vueper-slide v-for="(slide, index) in data" :key="slide.id"
                :style="'background-color: ' + ['#ff5252', '#42b983'][i % 2]">
                <template #content>

                  <img :src="require('@/assets/images/icons/' + slide.image)" alt="user print"
                    class="mb-0 mb-md-0 img_carousel" />
                  <div class="row">
                    <div class="col-xs-12 col-lg-12 col-xl-12 text-center"></div>
                    <div class="mt-0 text-left" style=" width: 428px;
                      heigh: 84px;
                      position: absolute;
                      top: 20px;
                      left: 60px;">
                      <h3 style="color: #f96419; margin-top: 48px">
                        {{ slide.title }}
                      </h3>
                      <p class="body_regular" style="color: #37474f">
                        {{ slide.text }}
                      </p>
                      <div v-if="index + 1 == data.length" class="mt-3 mt-md-5 mb-3" align="left">
                        <router-link to="/solicitudes" class="button-primary" style="
                          position: static;
                          width: 89px;
                          height: 32px;
                          left: 0px;
                          top: 140px;
                          padding:4px 10px;
                        "><span class="cta-small" style="width: 100%">Empezar</span></router-link>
                      </div>


                    </div>
                  </div>
                </template>
              </vueper-slide>
            </vueper-slides>



            <b-carousel id="carousel-1" v-model="slide" :interval="5000" controls indicators background="#fffff"
              img-width="524" img-height="280" style="text-shadow: #00000; margin-top: 56px"
              @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
              <b-carousel-slide img-blank v-for="slide in data" :key="slide.id">
                <img :src="require('@/assets/images/icons/' + slide.image)" alt="user print"
                  class="mb-0 mb-md-0 img_carousel" />
                <div class="row">
                  <div class="col-xs-8 col-lg-8 col-xl-8 text-left ml-4">
                    <h3 style="color: #f96419; margin-top: 48px">
                      {{ slide.title }}
                    </h3>
                    <p class="body_regular" style="color: #37474f">
                      {{ slide.text }}
                    </p>
                  </div>
                  <div class="col-xs-12 col-lg-6 col-xl-6 text-center"></div>
                </div>
              </b-carousel-slide>
            </b-carousel>
          </div>
          <div v-if="activeBtn == 'Ajustes'">
            <p>
              <UpdatePoints />
            </p>
          </div>
          <div v-if="activeBtn == 'Actualizacion'">
            <p>
              <UpdateInfo />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- #page-onboarding -->
</template>

<script>
import MainBarMenuV2 from "../../components/layouts/MainBarMenuV2.vue";
import HeadingUser from "../../components/user/HeadingUser.vue";
import UpdateInfo from "../platformsettings/updateInfo.vue";
import UpdatePoints from "../platformsettings/updatePoints.vue";
import serverConfig from "./../../services/config";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'


export default {
  name: "AllSettings",
  components: {
    MainBarMenuV2,
    HeadingUser,
    UpdateInfo,
    UpdatePoints,
    VueperSlides,
    VueperSlide,
  },
  data() {
    return {
      activeBtn: "Comofunciona",
      serverPath: serverConfig.permisosURL,
      data: [
        {
          image: "Documents.svg",
          title: "Ten el control de la información",
          text: "Hemos creado increibles funcionalidades para que puedas editar toda la información de los negocios retail de la compañia. ¡Anímate a probarlo!",
        },
        {
          image: "Documents2.svg",
          title: "Modifica los puntajes al instante",
          text: "Ahora podras editar y actualizar en tiempo real las decisiónes tomadas en los Comites de Propina. ¿Qué esperas para probarlo?",
        },
      ],
      slide: 0,
      sliding: null,
    };
  },
  methods: {
    ActiveBtnComofunciona() {
      this.activeBtn = "Comofunciona";
    },

    ActivebtnAjustes() {
      this.activeBtn = "Ajustes";
    },
    ActivebtnActualizacion() {
      this.activeBtn = "Actualizacion";
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style lang="scss">
#allsettings {
  .cont-carousel {
    margin-top: 24px;
    left: 6%;
  }

  .carousel-inner {
    overflow: inherit;
    left: -15%;
  }

  .carousel-indicators {
    // left:-15%;
    margin-left: 0;
  }

  .carousel-control-next {
    left: 670px !important;
  }

  .carousel-control-prev {
    left: 640px !important;
  }
}
</style>
<style lang="scss" scoped>
#allsettings {
  .nav-tabs {
    a {
      color: black;
      padding: 5px 15px;
    }

    a.active {
      background: rgba(38, 152, 135, 0.06);
      border-radius: 4px;
      border: 0;
      border-bottom: solid 3px;
      border-color: #269887;
    }
  }
}

.content-toggle {
  /* _tab variants / horizontal */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  border: none;
  box-sizing: border-box;

  position: static;
  width: 376px;
  height: 56px;
  left: 28px;
  top: 228px;

  /* Inside auto layout */

  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 30px 0px;

  .Comofunciona {
    /* Auto layout */

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2px;

    position: static;
    width: 16px;
    height: 16px;
    //left: 128px;
    top: 12px;

    /* highlight/info/medium */

    background: #0075ff;
    border-radius: 100px;
    font-family: "Ubuntu";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 11px;
    /* identical to box height */

    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;

    /* Inside auto layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 0px 8px;


  }

  .toggle-search {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px;

    position: static;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;

    /* CTA/00 */

    background: #ececff;
    /* CTA/01 */

    border: 1px solid #c9caff;
    box-sizing: border-box;
    border-radius: 48px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 0px;
  }



}

.img_carousel {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 16px;
}
</style>